import React from "react";
import { useLockBACSRun } from "./api";
import { publish } from "./pubSub";

import { PanelDialog, PanelActions, Button, PanelRow, PanelHeading } from "@backslashbuild/pp-ui";

export default function LockDialog({ open, onClose, bacsRunId }) {
  const post = useLockBACSRun();

  async function handleConfirm() {
    const res = await post({ bacsRunId });

    if (res.isSuccess) {
      publish("notification", "Success! The bacs run has been locked.");
      onClose();
    } else {
      publish(
        "notification",
        <div>
          Attempt Failed
          <ul>
            {res?.errors?.map((error) => (
              <li>{error}</li>
            ))}
          </ul>
        </div>
      );
    }
  }

  return (
    <PanelDialog open={open} onClose={onClose}>
      <PanelHeading>Lock BACS Run</PanelHeading>
      <PanelRow>
        <p>
          Click on 'Confirm' to lock this BACS Run. While locked, no payslips can be added or
          removed from the BACS Run. A BACS Run can be unlocked as long as it has not been already
          marked as paid.
        </p>
      </PanelRow>
      <PanelActions>
        <Button variant="secondary" onClick={() => onClose()}>
          Cancel
        </Button>
        <Button
          onClick={() => {
            handleConfirm();
            onClose();
          }}
        >
          Confirm
        </Button>
      </PanelActions>
    </PanelDialog>
  );
}
